/**
 * Design Tokens
 * Core primitive values used throughout the application
 * These are the single source of truth for colors, spacing, and other design values
 */

// Color Palette
export const colors = {
  // Primary theme colors (blue theme from saved parameters)
  primary: '#218aff',
  primaryHover: 'rgba(33, 138, 255, 0.5)',
  primaryActive: 'rgba(33, 138, 255, 0.15)',
  primarySolid: '#218aff',
  primaryDark: '#1a6fcc',

  // Surface colors
  background: '#111',
  surface: '#1a1a1a',
  surfaceHover: '#242424',
  surfaceElevated: '#1f2937', // Gray-800 for elevated components like buttons
  border: '#333',
  borderHover: 'rgba(33, 138, 255, 0.5)',
  borderActive: '#218aff',

  // Text colors
  textPrimary: '#fff',
  textSecondary: '#b0b0b0',
  textMuted: '#666',

  // State colors
  success: '#10b981',
  successHover: '#0ea572',
  error: '#ef4444',
  errorHover: '#dc2626',
  warning: '#f59e0b',
  warningHover: '#d97706',

  // Legacy colors (for gradual migration)
  legacyGreen: '#1DB954', // Old Spotify green
  legacyGreenHover: '#1DB95433',
};

// Spacing Scale
export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '32px',
  '4xl': '48px',
};

// Border Radius
export const borderRadius = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  full: '9999px',
};

// Shadows
export const shadows = {
  sm: '0 1px 2px rgba(0, 0, 0, 0.4)',
  md: '0 2px 4px rgba(0, 0, 0, 0.4)',
  lg: '0 4px 12px rgba(33, 138, 255, 0.3)',
  hover: '0 4px 12px rgba(33, 138, 255, 0.3)',
};

// Transitions
export const transitions = {
  fast: 'all 0.15s ease',
  base: 'all 0.2s ease',
  slow: 'all 0.3s ease',
  transform: 'transform 0.2s ease',
  colors: 'background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease',
};

// Transform Effects
export const transforms = {
  hoverLift: 'translateY(-2px)',
  activePress: 'scale(0.98)',
  selectedScale: 'scale(1.02)',
};

// Z-Index Scale
export const zIndex = {
  dropdown: 100,
  sticky: 200,
  modal: 1000,
  popover: 1100,
  tooltip: 1200,
  notification: 1300,
};

// Export all tokens as a single object for convenience
export const tokens = {
  colors,
  spacing,
  borderRadius,
  shadows,
  transitions,
  transforms,
  zIndex,
};

export default tokens;